import { render, staticRenderFns } from "./Ymx_authorization.vue?vue&type=template&id=eee7fdaa"
import script from "./Ymx_authorization.vue?vue&type=script&lang=js"
export * from "./Ymx_authorization.vue?vue&type=script&lang=js"
import style0 from "./Ymx_authorization.vue?vue&type=style&index=0&id=eee7fdaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports